module.exports = __webpack_public_path__ + "img/img-3.f3c536e7.webp";